<h2 mat-dialog-title>{{ 'invitationsDialog.ultimateBeneficialOwnershipAttestationInvitations' | transloco }}</h2>
<mat-dialog-content>
    <table mat-table [dataSource]="invitations" multiTemplateDataRows class="mat-elevation-z2">
        <ng-container matColumnDef="added">
            <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.added' | transloco }} </th>
            <td mat-cell *matCellDef="let invitation"> {{ invitation.added | localizedDate }} </td>
        </ng-container>

        <ng-container matColumnDef="expiresAt">
            <th mat-header-cell *matHeaderCellDef> {{ 'invitationsDialog.expiresAt' | transloco }} </th>
            <td mat-cell *matCellDef="let invitation"> {{ invitation.expiresAt | localizedDate }} </td>
        </ng-container>

        <ng-container matColumnDef="isUsed">
            <th mat-header-cell *matHeaderCellDef> {{ 'invitationsDialog.hasBeenUsed' | transloco }} </th>
            <td mat-cell *matCellDef="let invitation"> {{ invitation.isUsed ? 'Yes' : 'No' }} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
        </tr>
    </table>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button [mat-dialog-close]="true">{{ 'common.buttons.close' | transloco }}</button>
</mat-dialog-actions>